import { useEffect, useState } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

function NavbarMain() {
  const locaiton = useLocation()
  const pathname = locaiton.pathname
  const { id } = useParams()

  const menuSubList = useSelector((state) => state.allMenuReducer.allMenu)
  const [newMenu, setNewMenu] = useState([])
  const [newSubMenu, setNewSubMenu] = useState([])

  useEffect(() => {
    if (menuSubList?.allMenu) {
      const menuMain = menuSubList.allMenu.find((item) => item.id === 11) //id emp

      if (menuMain) {
        const subMenu = menuMain.submenu.find((item) => item.menuId === 5) //id cln

        if (subMenu?.menuSubList.length > 0) {
          setNewMenu(subMenu?.menuSubList ?? [])

          const subMenuList = subMenu?.menuSubList.find(
            (item) => item.menuId === 7
          ) //id Employee Info

          setNewSubMenu(subMenuList?.menuSubList ?? [])
        }
      }
    }
  }, [menuSubList])

  const getLinkQuery = (url) => {
    return `${url}/${id}`
  }


  const menus = newMenu.map((m, index) => {
    const subMenu = newSubMenu[index]

    return {
      ...m,
      // id: uuidv4(),
      // menuId: index + 1,
      // label: m.label,
      link: getLinkQuery(m.menuId === 7 ? subMenu?.link : m.link)
    }
  })

  const chkIsSubMenu = (d) => {
    const path =
      pathname.split('/')[1] + pathname.split('/')[2] + pathname.split('/')[3]
    const link =
      d.link.split('/')[1] + d.link.split('/')[2] + d.link.split('/')[3]
    return path === link
  }

  return (
    <div
      className="d-flex justify-content-between p-3 bg-white rounded-top border-bottom"
      style={{ maxHeight: '55px', minHeight: '55px' }}
    >
      <div>
        {menus.map((m, i) => (
          <Link
            to={m.link}
            key={i}
            style={{ whiteSpace: 'nowrap', fontSize: '18px' }}
            className={`me-4  text-reset text-decoration-none  ${
              chkIsSubMenu(m) ? '' : 'opacity-25'
            }`}
          >
            {m?.label}
          </Link>
        ))}
      </div>
    </div>
  )
}

export default NavbarMain
